import React from 'react';
import { Logo } from './Logo';
export function Footer() {
  return <footer className="bg-[#1a202c] pt-16 pb-8" data-id="element-61">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-62">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-63">
          <div className="col-span-1 md:col-span-1" data-id="element-64">
            <div className="mb-6" data-id="element-65">
              <Logo size="large" data-id="element-66" />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-67">
              Empowering more efficient patient care through modern healthcare
              software solutions.
            </p>
          </div>

          <div data-id="element-68">
            <h4 className="text-white font-semibold mb-4" data-id="element-69">Product</h4>
            <ul className="space-y-3" data-id="element-70">
              <li data-id="element-71">
                <a href="#features" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-72">
                  Features
                </a>
              </li>
              <li data-id="element-73">
                <a href="#pricing" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-74">
                  Pricing
                </a>
              </li>
              <li data-id="element-75">
                <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-76">
                  Payer List
                </a>
              </li>
              <li data-id="element-77">
                <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-78">
                  Sign Up
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-79">
            <h4 className="text-white font-semibold mb-4" data-id="element-80">Company</h4>
            <ul className="space-y-3" data-id="element-81">
              <li data-id="element-82">
                <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-83">
                  About Us
                </a>
              </li>
              <li data-id="element-84">
                <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-85">
                  Contact
                </a>
              </li>
              <li data-id="element-86">
                <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-87">
                  Careers
                </a>
              </li>
              <li data-id="element-88">
                <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-89">
                  Blog
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-90">
            <h4 className="text-white font-semibold mb-4" data-id="element-91">Support</h4>
            <ul className="space-y-3" data-id="element-92">
              <li data-id="element-93">
                <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-94">
                  Help Center
                </a>
              </li>
              <li data-id="element-95">
                <a href="#faq" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-96">
                  FAQ
                </a>
              </li>
              <li data-id="element-97">
                <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-98">
                  System Status
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-99">
          <p className="text-gray-500 text-sm mb-4 md:mb-0" data-id="element-100">
            &copy; {new Date().getFullYear()} EN Medical Systems. All rights
            reserved.
          </p>
          <div className="flex space-x-6" data-id="element-101">
            <a href="#" className="text-gray-500 hover:text-white text-sm transition-colors" data-id="element-102">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-500 hover:text-white text-sm transition-colors" data-id="element-103">
              Terms of Service
            </a>
            <a href="#" className="text-gray-500 hover:text-white text-sm transition-colors" data-id="element-104">
              HIPAA Compliance
            </a>
          </div>
        </div>
      </div>
    </footer>;
}